//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import Header from "../../component/common/Header";
import Pay from "./components/Pay";
import Footer from "../../component/common/Footer";
import DefaultModal from "../../component/popup/DefaultModal";
import BasicBtn from "../../component/button/BasicBtn";
import InnerCon from "../../component/layouts/InnerCon";

export default function PayPage() {
    // 경고 모달
    const [errorModal, setErrorModal] = useState(false);

    // 경고 리스트
    const modalTextList = (modalText) => {
        switch (modalText) {
            case 0:
                return <>수령인 이름을 입력해 주세요.</>;
            case 1:
                return <>배송지를 입력해주세요.</>;
            case 2:
                return <>수령인 연락처를 입력해 주세요.</>;
            case 3:
                return <>주문 상품정보에 대해 동의해주세요.</>;
            case 4:
                return <>결제수단을 선택해주세요.</>;
            default:
            // do nothing
        }
    };

    return (
        <>
            <Wrap>
                <Header />
                <InnerCon>
                    <Pay setErrorModal={setErrorModal} />
                </InnerCon>
                <Footer />
            </Wrap>

            {/* 모달 */}
            {/* 상황에따라 각각의 팝업 텍스트 노출해주세요!*/}
            {/* text={modalTextList(숫자)) */}
            {/* 1. 수령인 이름 누락
                2. 배송지
                3. 수령인 연락처
                4. 주문 상품정보에 대해 동의
                5. 결제수단
            */}
            {errorModal && <DefaultModal closeModal={() => setErrorModal(false)} Simple={true} text={modalTextList(4)} />}
        </>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
